import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'src/helpers/fetchQueryHelper';

export const carrierEngineApi = createApi({
  reducerPath: 'carrierEngineApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTopCarriers: builder.mutation<
      Array<{
        carrierId: number;
        carrierName: string;
        label: string;
        rankLabel: 'Very Good' | 'Good' | 'Neutral' | 'Bad' | 'Very Bad';
      }>,
      { companyId: number; k?: number }
    >({
      query: ({ companyId, k }) => ({
        url: `/carrier-engine/topk/${companyId}` + (k ? `?k=${k}` : ''),
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetTopCarriersMutation } = carrierEngineApi;
